export const FETCH_ORDER_ENTRY_ALLCUSTOMERS_REQUEST =
  "FETCH_ORDER_ENTRY_ALLCUSTOMERS_REQUEST";
export const FETCH_ORDER_ENTRY_ALLCUSTOMERS_SUCCESS =
  "FETCH_ORDER_ENTRY_ALLCUSTOMERS_SUCCESS";
export const FETCH_ORDER_ENTRY_ALLCUSTOMERS_FAILURE =
  "FETCH_ORDER_ENTRY_ALLCUSTOMERS_FAILURE";

export const FETCH_ORDER_ENTRY_ALLVENDORS_REQUEST =
  "FETCH_ORDER_ENTRY_ALLVENDORS_REQUEST";
export const FETCH_ORDER_ENTRY_ALLVENDORS_SUCCESS =
  "FETCH_ORDER_ENTRY_ALLVENDORS_SUCCESS";
export const FETCH_ORDER_ENTRY_ALLVENDORS_FAILURE =
  "FETCH_ORDER_ENTRY_ALLVENDORS_FAILURE";
